import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { PaginationInstance } from 'ngx-pagination';
import { Store } from '@ngrx/store';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import {
    getProducts,
    getTotalProduct,
    ProductState,
} from '@app/selectors/shoppingmall/product.selector';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import {
    loadProducts,
    loadTotalProduct,
    setKeySearch,
} from '@app/actions/shoppingmall/product.action';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { environment } from '@enviroments/environment';
import { AuthUtil } from '@app/common/util/auth.util';

@Component({
    selector: 'app-product-search',
    templateUrl: './product-search.component.html',
    styleUrls: ['./product-search.component.css'],
})
export class ProductSearchComponent implements OnInit {
    products$ = new Observable<OrdPdtModel[]>();
    products: OrdPdtModel[] = [];

    total$ = new Observable<number>();
    total: number = 0;

    page: number = 1;
    len: number = 12;

    key: string = '';
    pathKind: string = 'PC';

    config: PaginationInstance = {
        id: 'product-search',
        itemsPerPage: this.len,
        currentPage: this.page,
        totalItems: this.total,
    };

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _productStore: Store<ProductState>,
        private _deviceService: DeviceDetectorService
    ) {
        this.total$ = this._productStore.select(getTotalProduct);
        this.products$ = this._productStore.select(getProducts);
    }

    ngOnInit(): void {
        this.pathKind = this._deviceService.isDesktop() ? 'PC' : 'PHONE';

        this._activatedRoute.queryParamMap.subscribe((params) => {
            let key = ConvertUtil.convertToString(params.get('key'));
            if (ValidationUtil.isNotNullAndNotEmpty(key)) {
                this.key = key;
                this._overlayLoadingStore.dispatch(
                    setShowOverlayLoading({ loading: true })
                );
                this.loadProducts();
                this.loadTotalProduct();
                setTimeout(() => {
                    this._productStore.dispatch(
                        setKeySearch({ key: this.key })
                    );
                }, 100);
            } else {
                this._router.navigate([MyProgramConstant.urlShopping]);
            }
        });

        combineLatest([this.total$, this.products$], (total, products) => ({
            total,
            products,
        })).subscribe((res) => {
            this.total = res.total;
            this.products = res.products;
            this._overlayLoadingStore.dispatch(
                setShowOverlayLoading({ loading: false })
            );
        });
    }

    onChangeLen(selected: SelectDropdownModel) {
        this.page = 1;
        this.len = Number(selected.value);
        this.config.currentPage = 1;
        this.config.itemsPerPage = this.len;

        this.loadProducts();
    }

    onChangePage(page: number) {
        this.page = page;
        this.config.currentPage = page;

        this.loadProducts();
    }

    loadTotalProduct(): void {
        this._overlayLoadingStore.dispatch(
            setShowOverlayLoading({ loading: true })
        );
        this._productStore.dispatch(
            loadTotalProduct({ params: this.getParamsSearchProduct() })
        );
    }

    loadProducts(): void {
        this._overlayLoadingStore.dispatch(
            setShowOverlayLoading({ loading: true })
        );
        this._productStore.dispatch(
            loadProducts({ params: this.getParamsSearchProduct() })
        );
    }

    getParamsSearchProduct() {
        return {
            comId: environment.comId,
            cateCd: "",
            pathKind: this.pathKind,
            key: this.key,
            page: this.page - 1,
            len: this.len,
            userId: AuthUtil.getUserId()
        }
    }
}
